// Simple model helpers for account payloads

export function buildAccountPayload(fields) {
  // fields: { name, cpf, email, phone, password, avatarFile }
  const payload = {
    name: fields.name || '',
    cpf: fields.cpf || '',
    email: fields.email || '',
    phone: fields.phone || '',
  };

  if (fields.password) payload.password = fields.password;
  if (fields.avatarFile) payload.file = fields.avatarFile;
  return payload;
}

export default { buildAccountPayload };
